import type { ShareData, ShareService } from '@/domain/shared/ShareService'

export class BrowserShareService implements ShareService {
  async share(data: ShareData): Promise<void> {
    if (!this.isSupported()) {
      throw new Error('Web Share API not supported')
    }
    return navigator.share(data)
  }

  isSupported(): boolean {
    return typeof navigator !== 'undefined' && !!navigator.share
  }
}
